import { TrendingUp } from 'lucide-react';
import { Card, CardHeader, Pill, type PillTone } from '../_primitives';

export interface ContentStat {
  label: string;
  value: string | number;
}

export interface ContentStatsCardProps {
  /** Total words in the document. */
  wordCount: number;
  /** Heading count (H1+H2+H3). */
  headings: number;
  /** Distinct focus terms covered. */
  focusTerms: number;
  /** Workflow status, e.g. "In review", "Draft". */
  status?: string;
  statusTone?: PillTone;
}

export function ContentStatsCard({
  wordCount,
  headings,
  focusTerms,
  status = 'In review',
  statusTone = 'success',
}: ContentStatsCardProps) {
  const stats: ContentStat[] = [
    { label: 'Words', value: wordCount.toLocaleString() },
    { label: 'Headings', value: headings },
    { label: 'Focus terms', value: focusTerms },
  ];

  return (
    <Card railSection="stats">
      <CardHeader
        icon={<TrendingUp className="size-3.5" />}
        title="Content stats"
        trailing={
          <Pill tone={statusTone} size="sm">
            {status}
          </Pill>
        }
      />
      <div className="px-3 pb-3 grid grid-cols-3 gap-1.5">
        {stats.map((s) => (
          <div key={s.label} className="bg-warm-bg rounded-md px-2 py-1.5 text-center">
            <div className="font-mono text-[14px] font-bold text-foreground leading-none">
              {s.value}
            </div>
            <div className="text-[10px] text-muted-foreground mt-0.5">{s.label}</div>
          </div>
        ))}
      </div>
    </Card>
  );
}
